import React from "react";
import { connect } from "react-redux";

import MapActioner from "services/map/actioner";

import HalfLayout from "components/HalfLayout";
import Map from "components/Map";
import FlowLayout from "./components/FlowLayout";
import MapComponent from "./components/MapComponent";

function Flow({ setCenterToDefault }) {
  return (
    <HalfLayout
      leftComponent={<FlowLayout />}
      rightComponent={
        <Map
          floorsButton
          withCheckboxOptions={{
            aisles: false,
            displays: false,
            spaceLabels: false,
          }}
          onRecenter={setCenterToDefault}
          mapComponent={<MapComponent onRecenter={setCenterToDefault} />}
        />
      }
    />
  );
}

const mapDispatchToProps = (dispatch) => ({
  setCenterToDefault: () => dispatch(MapActioner.setCenterToDefault()),
});

export default connect(null, mapDispatchToProps)(Flow);
